import React from 'react';
import { ContactMail, Phone, Emergency } from '@mui/icons-material';

const IncidentResponse = () => {
    return (
        <section className="py-16 bg-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-12">
                    <h2 className="text-3xl font-bold text-gray-900 mb-4">
                        Réponse aux Incidents
                    </h2>
                    <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                        Notre équipe de sécurité est disponible 24/7 pour répondre à tout incident.
                    </p>
                </div>

                <div className="grid md:grid-cols-3 gap-8 mb-12">
                    <div className="text-center p-6 bg-red-50 rounded-xl border border-red-200">
                        <Emergency className="text-4xl text-red-600 mx-auto mb-4" />
                        <h3 className="text-xl font-semibold text-gray-900 mb-2">Urgence Sécurité</h3>
                        <p className="text-gray-600 mb-4">En cas d'incident critique</p>
                        <div className="text-red-600 font-mono text-lg">+243 994 896 388</div>
                    </div>

                    <div className="text-center p-6 bg-amber-50 rounded-xl border border-amber-200">
                        <Phone className="text-4xl text-amber-600 mx-auto mb-4" />
                        <h3 className="text-xl font-semibold text-gray-900 mb-2">Support Technique</h3>
                        <p className="text-gray-600 mb-4">Assistance technique 24/7</p>
                        <div className="text-amber-600 font-mono text-lg">+243 994 896 388</div>
                    </div>

                    <div className="text-center p-6 bg-blue-50 rounded-xl border border-blue-200">
                        <ContactMail className="text-4xl text-blue-600 mx-auto mb-4" />
                        <h3 className="text-xl font-semibold text-gray-900 mb-2">Email Sécurité</h3>
                        <p className="text-gray-600 mb-4">Pour les rapports de vulnérabilités</p>
                        <div className="text-blue-600 font-mono text-sm">support@netikash.com</div>
                    </div>
                </div>

                <div className="bg-gray-900 rounded-2xl p-8 text-white">
                    <h3 className="text-2xl font-bold mb-6 text-center">Procédure de Signalement</h3>
                    <div className="grid md:grid-cols-4 gap-6 text-center">
                        <div>
                            <div className="w-12 h-12 bg-amber-500 rounded-full flex items-center justify-center mx-auto mb-3">
                                <span className="font-bold">1</span>
                            </div>
                            <h4 className="font-semibold mb-2">Détection</h4>
                            <p className="text-amber-100 text-sm">Identifiez l'incident</p>
                        </div>
                        <div>
                            <div className="w-12 h-12 bg-amber-500 rounded-full flex items-center justify-center mx-auto mb-3">
                                <span className="font-bold">2</span>
                            </div>
                            <h4 className="font-semibold mb-2">Containement</h4>
                            <p className="text-amber-100 text-sm">Isolez la menace</p>
                        </div>
                        <div>
                            <div className="w-12 h-12 bg-amber-500 rounded-full flex items-center justify-center mx-auto mb-3">
                                <span className="font-bold">3</span>
                            </div>
                            <h4 className="font-semibold mb-2">Investigation</h4>
                            <p className="text-amber-100 text-sm">Analyse de l'incident</p>
                        </div>
                        <div>
                            <div className="w-12 h-12 bg-amber-500 rounded-full flex items-center justify-center mx-auto mb-3">
                                <span className="font-bold">4</span>
                            </div>
                            <h4 className="font-semibold mb-2">Résolution</h4>
                            <p className="text-amber-100 text-sm">Correction et prévention</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default IncidentResponse;